

export default function TypeButton({ value, selected, onClick }) {
  return (
    <button
      onClick={() => onClick(value)}
      className={`
        px-4 py-2 rounded-full text-sm font-medium
        border transition-all duration-200
        whitespace-nowrap
        ${
          selected
            ? "bg-black text-white border-black shadow-sm"
            : "bg-white text-gray-700 border-gray-300 hover:border-black hover:text-black"
        }
      `}
    >
      {value}
    </button>
  );
}